import React from "react";
import Routing from "./routes/routing";
import MaintenancePage from "./components/ErrorBoundary/MaintenancePage";

const MAINTENANCE_MODE = false; // set to true to enable maintenance page

// No app-wide <Helmet> here on purpose: react-helmet-async v3 on React 19
// doesn't merge/dedupe tags across multiple mounted <Helmet> components (each
// renders its own literal DOM elements independently), so a root-level
// default Helmet would just duplicate whatever a page-level Helmet also sets
// instead of being overridden by it. Every route instead renders its own
// single <Helmet>, falling back to shared values from
// src/config/seoDefaults.js for anything it doesn't set itself.
function App() {
  if (MAINTENANCE_MODE) return <MaintenancePage />;

  return (
    <div>
      <Routing />
    </div>
  );
}

export default App;
